/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Assistant_DisabledInputs */

const en_error_assistant_disabled = /** @type {(inputs: Error_Assistant_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant is off. An administrator turns it on in Parameters.`)
};

/**
* | output |
* | --- |
* | "The assistant is off. An administrator turns it on in Parameters." |
*
* @param {Error_Assistant_DisabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_assistant_disabled = /** @type {((inputs?: Error_Assistant_DisabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Assistant_DisabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_assistant_disabled(inputs)
});